export const contentDuosWide_orbitvuResizer = (): void => {
  const resizeOrbitvu = (singleOrbitvu: HTMLElement) => {
    const currentWidth = singleOrbitvu.clientWidth
    singleOrbitvu.style.height = `${currentWidth * 0.66}px`
  }

  /* Handle all individual "Content Duos Wide" HTML blocks inside the individual "Content Duos Wide" HTML block */
  const handleIndividualOrbitvus = (contentDuosWideBlock: Element) => {
    const allDuoListWrapper = contentDuosWideBlock.querySelectorAll('.js-contentDuosWide-singleWrapper')

    /* Individual orbitvu contents */
    allDuoListWrapper.forEach((singleWrapper: Element) => {
      const singleOrbitvu = singleWrapper.querySelector('.js-contentDuosWide-singleOrbitvuWrapper') as HTMLElement

      if (singleOrbitvu) {
        // Add listeners
        window.addEventListener('resize', () => {
          resizeOrbitvu(singleOrbitvu)
        })
        // Run for the first time on page load
        resizeOrbitvu(singleOrbitvu)
      }
    })
  }

  /* Handle all individual "Content Duos Wide" HTML blocks on the page */
  const allContentDuosWideBlocks = document.querySelectorAll('.js-contentDuosWide')
  allContentDuosWideBlocks.forEach(contentDuosWideBlock => {
    handleIndividualOrbitvus(contentDuosWideBlock)
  })
}
